import { IGridServerSideDatasource, toQuery, IServerSideGetRowsParams } from '@samc/centricity-core';
import { AjaxHelper, IPaginatedList } from '@samc/common';
import { IReportScheduleDetail } from '@/Interfaces';
import { ensureISOUTC } from '@/utils';
import { formatInTimeZone } from 'date-fns-tz';

export class ReportScheduleDataSource implements IGridServerSideDatasource {
  public pageSize: number = 100;
  public cacheSize: number = 10;
  public adhocFilter: string = '';

  private _queryParams: any;

  public constructor(private _verificationToken: string | null) {
    this._queryParams = {};
  }

  public async getRows(params: IServerSideGetRowsParams) {
    try {
      const helper = new AjaxHelper('/componentapi/reportschedule', this._verificationToken, null, null);
      this._queryParams = toQuery(params);

      const result = await helper.getData<IPaginatedList<IReportScheduleDetail>>('', this._queryParams);
      result.items.forEach((item) => {
        if (item.nextFireTime != undefined) {

          const nextFireTimeUtc = ensureISOUTC(item.nextFireTime);
          const zonedTimeDisplay = formatInTimeZone(nextFireTimeUtc, window.__UI_TIMEZONE, window.__SCHEDULE_DATETIME_DISPLAY_FORMAT);

          item.nextFireTimeDisplay = zonedTimeDisplay;
        }
      });

      console.log(result);
      params.success({ rowData: result.items, rowCount: result.fullCount });
    } catch (err: any) {
      params.fail();
    }
  }
}